import React, { useRef } from "react";
import { PALETTE } from "../ThemeConstants";
import ContainerResponsive from "./ContainerResponsive";
import DetailsHeader from "./DetailsHeader";


export default function FullScreenVideo({ url, show, onClose }) {
  const videoRef = useRef(null);

  // Don't render anything if show is false
  if (!show) {
    return null;
  }

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 5000,
        backgroundColor: PALETTE.BLACK
      }}
      onContextMenu={e => e.preventDefault()}
    >
      <DetailsHeader handleClose={onClose} />
      <ContainerResponsive>
        <video
          ref={videoRef}
          src={url}
          className="rounded-md"
          style={{
            width: "100%",
            height: "85vh",
            objectFit: "contain",
            backgroundColor: "#000000", // Add black background to avoid white flash
          }}
          autoPlay
          controls
          controlsList="nodownload"
          playsInline
          muted={false} // Explicitly set muted state
          preload="auto" // Ensure video is preloaded
          onContextMenu={e => e.preventDefault()}
        />
      </ContainerResponsive>
    </div>
  );
}
